import React from 'react'
import { Grid, GridItem } from '@deal/components'
import step1Video from './clips/step-1.mp4'
import step2Video from './clips/step-2.mp4'
import step3Video from './clips/step-3.mp4'
import step4Video from './clips/step-4.mp4'
import TechCrunch from './techcrunch.svg'
import Cheddar from './cheddar.svg'
import FastCompany from './fast-company.svg'
import styles from './styles.css'
import PageContent from '../PageContent'

interface HowItWorksProps {
  actions: React.ReactNode
  showFeaturedLogosInFooter?: boolean
  className?: string
}

const HowItWorks: React.FC<HowItWorksProps> = ({
  actions,
  showFeaturedLogosInFooter,
  className
}) => {
  return (
    <div className={className}>
      <PageContent>
        <div className={styles.wrapper}>How it works</div>
      </PageContent>
      <Grid className={styles.bulletRow}>
        <GridItem col={2} smCol={4} mdCol={3} className={styles.bullet}>
          <div className={styles.icon}>
            <video
              autoPlay={true}
              muted
              playsInline
              controls={false}
              src={step1Video}
              className={styles.videoStep}
            />
          </div>
          <div className={styles.copy}>
            <div className={styles.copyHeader}>Tell us what you want</div>
            <div className={styles.body}>
              Answer a few questions and we’ll match you with a real expert
            </div>
          </div>
        </GridItem>
        <GridItem col={2} smCol={4} mdCol={3} className={styles.bullet}>
          <div className={styles.icon}>
            <video
              playsInline
              muted
              controls={false}
              autoPlay={true}
              src={step2Video}
              className={styles.videoStep}
            />
          </div>
          <div className={styles.copy}>
            <div className={styles.copyHeader}>Meet your expert</div>
            <div className={styles.body}>
              Your expert will get to know you and recommend the best products
            </div>
          </div>
        </GridItem>
        <GridItem col={2} smCol={4} mdCol={3} className={styles.bullet}>
          <div className={styles.icon}>
            <video
              playsInline
              muted
              controls={false}
              autoPlay={true}
              src={step3Video}
              className={styles.videoStep}
            />
          </div>
          <div className={styles.copy}>
            <div className={styles.copyHeader}>Find it together</div>
            <div className={styles.body}>
              Chat until you’re satisfied. Together you’ll pick the perfect thing
            </div>
          </div>
        </GridItem>
        <GridItem col={2} smCol={4} mdCol={3} className={styles.bullet}>
          <div className={styles.icon}>
            <video
              playsInline
              muted
              controls={false}
              autoPlay={true}
              src={step4Video}
              className={styles.videoStep}
            />
          </div>
          <div className={styles.copy}>
            <div className={styles.copyHeader}>Buy & enjoy </div>
            <div className={styles.body}>
              Buy directly from our site and rest easy knowing that you got the best
            </div>
          </div>
        </GridItem>
      </Grid>

      <div className={styles.actions}>{actions}</div>
      {showFeaturedLogosInFooter && (
        <div className={styles.logosContainer}>
          <div className={styles.logosHeader}>As featured in</div>
          <div className={styles.logos}>
            <a href="https://techcrunch.com/2019/10/30/forerunner-ventures-newest-bet-is-curated-a-marketplace-that-matches-pros-with-people-buying-high-ticket-items/">
              <TechCrunch className={styles.logo} />
            </a>
            <a href="https://cheddar.com/media/curated-launches-to-bring-human-touch-to-e-commerce">
              <Cheddar className={styles.logo} />
            </a>
            <a href="https://www.fastcompany.com/90424278/curated-startup-linkedin-exec-funding-kirsten-green-vc">
              <FastCompany className={styles.logo} />
            </a>
          </div>
        </div>
      )}
    </div>
  )
}

export default HowItWorks
